import React from 'react';
import cls from 'classnames';
import { useI18n } from '../../../../_contexts/I18nContext';
import { publicPath } from '@/utils';
import ArrowRight from '@/static/images/business/ArrowRight.svg';
import Anchor from '@/components/Anchor';
import { logger } from '@/pages/business/utils/lib';
import { ugMonitor, UG_EVENT } from '@/utils/ug-monitor';
import styles from './index.module.scss';

const Card = ({
  img,
  title,
  desc,
  link,
  clickFor
}) => {
  const I18n = useI18n();

  const handleClick = () => {
    ugMonitor(UG_EVENT.LEARN_MORN_CLICK);

    if (clickFor) {
      logger.sendButtonClick({
        click_for: clickFor
      });
    }
  };

  return /*#__PURE__*/React.createElement("section", {
    className: cls(styles.section)
  }, /*#__PURE__*/React.createElement("div", {
    className: cls(styles.container)
  }, /*#__PURE__*/React.createElement("img", {
    src: publicPath(img),
    alt: desc
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, title), /*#__PURE__*/React.createElement("p", null, desc)), link && /*#__PURE__*/React.createElement(Anchor, {
    target: link.indexOf('/business') !== 0 ? '_blank' : undefined,
    href: link,
    className: cls('btn btn-primary btn-lg', styles.btn),
    onClick: handleClick
  }, I18n.t('TTS_Portal_HP_2x2Multi_scene_1_btn_learn_more'), " ", /*#__PURE__*/React.createElement(ArrowRight, null)))));
};

export default Card;